import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import CustomAxios from '../../../../utility/customAxios';
import { queryClient } from '../../queryClient';
import { queryKeys } from '../../queryKeys';

export const postRefreshGoogleAuth = async () => {
  const response = await CustomAxios.post(`integrations/google/refresh`);
  const { data } = response;
  return data;
};

interface ErrorResponse {
  error: string;
  message?: string;
}

export function useRefreshGoogleAuth() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: postRefreshGoogleAuth,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.organizationIntegrations],
      });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data = err?.response?.data as ErrorResponse;
        if (data.error === 'GOOGLE_AUTH_TOKEN_EXPIRED' || data.error === 'GOOGLE_AUTH_MISSING') {
          navigate('/oauth2redirect-google');
        }
      }
    },
  });
}
